export const DISTRICT_REP_DETAILS = {
  "1": {
    name: "Caoimhín Mac Colaim",
    email: "cmaccolaim@into.ie"
  },
  "2": {
    name: "Annmarie Conway",
    email: "amconway@into.ie"
  },
  "3": {
    name: "Aine McGinley",
    email: "amcginley@into.ie"
  },
  "4": {
    name: "Máire C. English",
    email: "mcenglish@into.ie"
  },
  "5": {
    name: "Adrian Kelly",
    email: "akelly@into.ie"
  },
  "6": {
    name: "Gerard Murray",
    email: "gmurray@into.ie"
  },
  "7": {
    name: "Peter O'Toole",
    email: "potoole@into.ie"
  },
  "8": {
    name: "Alice O'Donnell",
    email: "aodonnell@into.ie"
  },
  "9": {
    name: "Órlaith Ní Fhoghlú",
    email: "onifhoghlu@into.ie"
  },
  "10": {
    name: "Deirdre Fleming",
    email: "dfleming@into.ie"
  },
  "11": {
    name: "Gareth Heagney",
    email: "gheagney@into.ie"
  },
  "12": {
    name: "Edel Polly",
    email: "epolly@into.ie"
  },
  "13": {
    name: "Tracie Tobin",
    email: "ttobin@into.ie"
  },
  "14": {
    name: "Stephen Marken",
    email: "smarken@into.ie"
  },
  "15": {
    name: "Máire Lineen",
    email: "mlineen@into.ie"
  },
  "16": {
    name: "Siobhan Buckley",
    email: "sbuckley@into.ie"
  }
}

export const OTHER_EMAILS = [
  {
    name: "Brendan Horan",
    position: "President",
    email: "bhoran@into.ie",
  },
  {
    name: "Seamus Hanna",
    position: "Vice President",
    email: "shanna@into.ie",
  },
  {
    name: "John Boyle",
    position: "General Secretary",
    email: "jboyle@into.ie",
  },
  {
    name: "Deirdre O'Connor",
    position: "General Treasurer",
    email: "doconnor@into.ie",
  },
  {
    name: "Mark McTaggart",
    position: "Northern Secretary",
    email: "mmctaggart@into.ie",
  }
]